import { createContext } from "react";

export const TotalItemsContext = createContext<number>(-1);
export const TotalItemsDispatchContext = createContext<
  React.Dispatch<{
    type: "updateTotalCount" | "setTotalCount";
    payload: number;
  }>
>(() => {});

export const totalItemsReducrer = (
  state: number,
  action: { type: "updateTotalCount" | "setTotalCount"; payload: number }
) => {
  switch (action.type) {
    case "setTotalCount": {
      return action.payload;
    }
    case "updateTotalCount": {
      return state + action.payload;
    }
    default:
      return state;
  }
};
